import { Component, input, output } from '@angular/core';
import { NOTIFICATION_ICONS, NOTIFICATION_LABELS, SystemNotification } from '../../../core/models/system-notification';
import { MessageIconComponent } from '../system-messages/message-icon.component';

@Component({
  selector: 'app-custom-snackbar',
  imports: [MessageIconComponent],
  template: `
    <div [class]="'snackbar ' + data().type">
      <app-message-icon class="type-icon" [name]="icons[data().type]" />
      <div class="content">
        <div role="status" aria-atomic="true">
          <strong>{{ data().title || labels[data().type] }}</strong>
          <span class="source">{{ data().source }} · {{ data().operation || 'Message' }}</span>
          <p>{{ data().message }}</p>
        </div>
        @if (data().occurrences > 1) { <span class="repeat">Répété {{ data().occurrences }} fois</span> }
        <button class="review" (click)="review.emit()">Lire les messages ({{ unreadCount() }})
          <app-message-icon name="arrow_forward" />
        </button>
        <small>Conservé dans Messages système.</small>
      </div>
      <button class="close" (click)="dismiss.emit()" aria-label="Fermer l’aperçu" title="Fermer l’aperçu, conserver le message">
        <app-message-icon name="close" />
      </button>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .snackbar { --accent: #0369a1; display: flex; gap: 12px; padding: 18px; background: white; color: #243247;
      border: 1px solid #dce4ea; border-left: 4px solid var(--accent); border-radius: 14px;
      box-shadow: 0 12px 36px #15314724; }
    .error { --accent: #b42318; } .warning { --accent: #925700; } .success { --accent: #087d72; }
    .type-icon { color: var(--accent); font-size: 24px; }
    .content { flex: 1; min-width: 0; } strong { font-size: 14px; } .source { display: block; font-size: 12px; color: #596779; margin-top: 3px; }
    p { font-size: 14px; line-height: 1.5; margin: 10px 0; overflow-wrap: anywhere; display: -webkit-box;
      -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
    button { cursor: pointer; font: inherit; } button:focus-visible { outline: 2px solid #087d72; outline-offset: 3px; }
    .close { align-self: flex-start; border: 0; background: transparent; color: #596779; padding: 3px; border-radius: 6px; }
    .review { display: flex; align-items: center; gap: 6px; border: 0; background: #eef7f6; color: #076b63;
      border-radius: 7px; padding: 8px 10px; font-size: 12px; font-weight: 600; }
    .review app-message-icon { font-size: 14px; }
    small { display: block; color: #64748b; font-size: 11px; margin-top: 7px; }
    .repeat { display: block; color: var(--accent); font-size: 12px; margin-bottom: 8px; }
  `],
})
export class CustomSnackbarComponent {
  readonly data = input.required<SystemNotification>();
  readonly unreadCount = input(0);
  readonly dismiss = output<void>();
  readonly review = output<void>();
  readonly icons = NOTIFICATION_ICONS;
  readonly labels = NOTIFICATION_LABELS;
}
